<template>
  <div id="rolegorup-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px;">
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>{{this.$t('event.table.title')}}</label>
                    <el-input
                      placeholder
                      v-model="form.title"
                      :class="$inputError('title', validationErrors)"
                    ></el-input>
                    <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-md-12"
                    :key="index"
                    v-for="(item, index) in getAllRoles"
                  >
                    <div style="width: 100%; margin-top: 15px; margin-bottom: 5px;">
                      <span>{{ item.title }}</span>
                      <el-button
                        size="mini"
                        type="success"
                        style="float: right"
                        @click="selectAll(index)"
                      >{{$t('options.selectAll')}}</el-button>
                    </div>

                    <el-select
                      v-model="getAllRoles[index].selectedRoles"
                      :placeholder="$t('authorityGroup.selectAuthorizations')"
                      multiple
                      style="margin-top: 5px"
                    >
                      <el-option
                        v-for="(i,index) in item.roles"
                        :key="item.name + index"
                        :label="i.title"
                        :value="item.name + i.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 0;
                  margin-top: 20px"
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t('event.table.delete') }}</el-button>
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="display: flex; flex: 1; align-items: center; justify-content: flex-end"
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                      >{{$t('event.buttons.close')}}</el-button>
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="display: flex; width: 100%; align-items: center; justify-content: center; cursor: pointer; padding: 10px 0px"
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";
export default {
  components: { ItemInfo, quillEditor },
  name: "RoleGroupAddUpdate",
  props: ["data"],

  data() {
    return {
      form: {
        id: null,
        title: null,
        roleNames: []
      },
      axios,
      validationErrors: [],
      showInfo: false,
      moment
    };
  },
  computed: {
      getAllRoles() {
      return this.$store.getters.getLoadAllRoles;
    },
  },
  methods: {
    async checkedId(){
      if(data != null){
        var res = await this.$store.dispatch("getRoleOrg", this.data);
        this.form = res;
      }else {
        this.form = {
          id: null,
          title: null,
          roleNames: []
        }
      }
    },
    selectAll(roleIndex) {
      this.getAllRoles[roleIndex].roles.map((item, index) => {
        if (
          this.getAllRoles[roleIndex].selectedRoles.some(
            k => k == this.getAllRoles[roleIndex].name + item.name
          ) == false
        ) {
          this.getAllRoles[roleIndex].selectedRoles.push(
            this.getAllRoles[roleIndex].name + item.name
          );
        }
      });
    },

    deleteItem() {
      var index = this.$store.state.subevents.items.findIndex(
        k => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },

    save() {
      this.validationErrors = [];

      var roles = [];

      this.getAllRoles.map((item, index) => {
        roles = [...roles, ...item.selectedRoles];
      });
      axios
        .post("role/addorupdate", {
          ...this.form,
          roleNames: roles
        })
        .then(async res => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded", res.data.data);
              this.form = {
                id: null,
                title: null,
                roleNames: []
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }

          await this.$store.dispatch("getOrganizationTeamContent")
          this.$emit('closeMe');
        });
    },
  },

  watch: {
    data: function(newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = {
          ...this.data
        };
        //console.log(this.form);
        //console.log(this.data)
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          roleNames: []
        };
      }
    }
  },
  computed: {
      getAllRoles() {
      return this.$store.getters.getLoadAllRoles;
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = {
        ...this.data
      };
    } 
  },

  beforeDestroy() {
    this.updateForm = null
  }

};
</script>



// WEBPACK FOOTER //
// src/components/RoleGroupAddUpdate.vue